import { DateTime } from 'luxon';

function convertDate(data, slash = false, ore = false) {
  let dateTime;

  // Se data è una stringa
  if (typeof data === 'string') {
    // Sempre parse come stringa in formato 'yyyyMMddHHmm'
    if (data.length===12)
    {dateTime = DateTime.fromFormat(data, 'yyyyMMddHHmm',{ zone: 'utc' });}
    else {dateTime = DateTime.fromFormat(data, 'yyyyMMdd',{ zone: 'utc' });}

    if (slash) {
      return ore
        ? dateTime.toFormat('dd/MM/yyyy, HH:mm')
        : dateTime.toFormat('dd/MM/yyyy');
    } else {
      return dateTime; // Ritorna oggetto DateTime
    }
  }

  // Se data è un oggetto Luxon DateTime
  if (data?.isLuxonDateTime) {
    dateTime = data.setZone('Africa/Nairobi');

    if (slash) {
      return ore
        ? dateTime.toFormat('dd/MM/yyyy, HH:mm')
        : dateTime.toFormat('dd/MM/yyyy');
    } else {
      return ore
        ? dateTime.toFormat('yyyyMMddHHmm')
        : dateTime.toFormat('yyyyMMdd');
    }
  }
  throw new Error('Input non valido: data deve essere una stringa o un oggetto Luxon DateTime.');
}

export default convertDate;
